import React from 'react';

import { SubAbas } from './subabas';
import MedsusIndex from '../../daf/ProdutosDAF/MedSUS';

const MedsusIndexSes: React.FC = () => {
  return (
    <>
      <MedsusIndex subAbas={SubAbas} />
    </>
  );
};

export default MedsusIndexSes;
